@if (formField.label) {
    <label for="form-element-{{ formField.id }}{{ labelForPostfix }}" class="form-element-label">
        {{ formField.label }}{{ formField.isRequired ? ' *' : '' }}
    </label>
}
